// SectionNav — the sub-navigation under a section (Videos → Library ·
// Create · Pipeline, …). Route-based links, so every sub-page has a URL and the
// browser's back button works; the active link carries aria-current="page".

import { Link } from '@tanstack/react-router';
import { cn } from '@/lib/cn';
import type { NavItem } from './navItems';

const TAB =
  'inline-flex min-h-9 shrink-0 items-center rounded-md px-3 py-1.5 text-sm font-medium ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus';

export function SectionNav({ label, items }: { label: string; items: readonly NavItem[] }): JSX.Element {
  return (
    <nav
      aria-label={label}
      className="flex items-center gap-1 overflow-x-auto border-b border-border-subtle bg-surface-0 px-4 py-1.5"
    >
      {items.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className={cn(TAB, 'text-fg-muted hover:bg-surface-2 hover:text-fg-default')}
          activeProps={{
            className: cn(TAB, 'bg-accent-3 text-accent-12'),
            'aria-current': 'page',
          }}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
}
